module.exports = __webpack_public_path__ + "img/84-be7ce6.png";